import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, useTheme } from "@mui/material";
import "./Information.scss";

const Comments = ({
  text,
  maxLength = null, // Ahora puede ser null
  maxLines = 4,
  rounded = false,
  border = "",
  background = "",
  padding = "15px 18px",
  color,
  variant = "body1",
  fontSize = 16,
  showAtEnd = false,
  ...rest
}) => {
  const theme = useTheme();
  const [t] = useTranslation("information");
  const [expanded, setExpanded] = useState(false);
  const [showExpandButton, setShowExpandButton] = useState(false);
  const textRef = useRef(null);

  const isLengthLimited = maxLength && text.length > maxLength;

  useEffect(() => {
    if (isLengthLimited) {
      setShowExpandButton(true);
      return;
    }

    const element = textRef.current;
    if (element) {
      const computedStyle = window.getComputedStyle(element);
      const lineHeight = parseFloat(computedStyle.lineHeight);
      const totalLines = Math.round(element.scrollHeight / lineHeight);
      setShowExpandButton(totalLines > maxLines);
    }
  }, [text, fontSize, maxLines, maxLength]);

  const getTextToRender = () => {
    if (expanded || !isLengthLimited) return text;
    return text.slice(0, maxLength) + "...";
  };

  return (
    <Box
      className={`comments ${rounded ? "rounded" : "semi-rounded"}`}
      sx={{
        background: theme?.palette[background]?.main || "transparent",
        padding,
        whiteSpace: "pre-line",
        overflow: "hidden",
      }}
      {...rest}
    >
      <Typography
        ref={textRef}
        variant={variant}
        className="p-0 m-0"
        {...(color && { color })}
        fontSize={fontSize}
        sx={
          !isLengthLimited
            ? {
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                WebkitLineClamp: expanded ? "unset" : maxLines,
              }
            : undefined
        }
      >
        {getTextToRender()}
      </Typography>

      {showExpandButton && (
        <Box
          sx={{
            display: "flex",
            justifyContent: showAtEnd ? "flex-end" : "flex-start",
            marginTop: showAtEnd ? "8px" : "0",
          }}
        >
          <b
            onClick={() => setExpanded(!expanded)}
            className="mx-2"
            style={{ cursor: "pointer", color: theme.palette.primary.main }}
          >
            {expanded ? t("information.see_less") : t("information.see_more")}
          </b>
        </Box>
      )}
    </Box>
  );
};

export default Comments;